export default {
  meta: {
    title: '案例详情',
  }
};
